import React, { useState } from "react";
import { useForm } from "react-hook-form";
import PhoneInput from "react-phone-number-input/react-hook-form";
import ApartmentDetails from "./Form/ApartmentDetails";
import ApartmentTitle from "./Form/ApartmentTitle";
import InfoFooter from "./Form/InfoFooter";
import InfoHeader from "./Form/InfoHeader";
import leadsConfig from "../../config/leads";
import analytics from "../../utils/analytics";
import LoadingIndicator from "../LoadingIndicator";
import "react-phone-number-input/style.css";

const STATE_OPEN = "open";
const STATE_SUBMITTING = "submitting";
const STATE_SUBMITTED = "sent";
const STATE_ERROR = "error";

export default function ReservationForm({ apartment }) {
  const [state, setState] = useState(STATE_OPEN);
  const onSubmit = (input) => {
    setState(STATE_SUBMITTING);
    const payload = JSON.stringify({
      ...input,
      key: apartment.key,
      target: apartment.key, // stupid inconsistent api conditions
    });
    fetch(leadsConfig.getLeadsApiUrl(), { method: "POST", body: payload })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error sending form data");
        }
        return response;
      })
      .then(() => {
        analytics.pushEvent(
          analytics.createReservationFormSubmitEvent(apartment)
        );
        setState(STATE_SUBMITTED);
      })
      .catch(() => {
        setState(STATE_ERROR);
      });
  };
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  if (state === STATE_OPEN) {
    return (
      <div>
        <InfoHeader apartment={apartment} />
        <ApartmentTitle apartment={apartment} />
        <ApartmentDetails apartment={apartment} />
        <div className="mb-3">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid w-4/5 grid-cols-1 gap-4 lg:grid-cols-2">
              <label className="flex flex-col">
                <span>Etunimi *</span>
                <input
                  type="text"
                  className="h-10 p-1 bg-white border border-laptiorange"
                  maxLength="50"
                  {...register("firstName", { required: true })}
                ></input>
                {errors.firstName && (
                  <span className="text-laptiorange">
                    Etunimi on vaadittu tieto
                  </span>
                )}
              </label>
              <label className="flex flex-col">
                <span>Sukunimi *</span>
                <input
                  type="text"
                  className="h-10 p-1 bg-white border border-laptiorange"
                  maxLength="50"
                  {...register("lastName", { required: true })}
                ></input>
                {errors.lastName && (
                  <span className="text-laptiorange">
                    Sukunimi on vaadittu tieto
                  </span>
                )}
              </label>
              <label className="flex flex-col">
                <span>Puhelinnumero *</span>
                <PhoneInput
                  control={control}
                  name="phone"
                  rules={{ required: true }}
                  defaultCountry={"FI"}
                  limitMaxLength={true}
                  countryOptionsOrder={["FI", "|", "..."]}
                  className="h-10 p-1 bg-white border border-laptiorange"
                  numberInputProps={{
                    className: "focus:outline-none",
                  }}
                />
                {errors.phone && (
                  <span className="text-laptiorange">
                    Puhelinnumero on vaadittu tieto
                  </span>
                )}
              </label>
              <label className="flex flex-col">
                <span>Sähköposti *</span>
                <input
                  type="email"
                  name="email"
                  className="h-10 p-1 bg-white border border-laptiorange"
                  maxLength="100"
                  {...register("email", { required: true })}
                ></input>
                {errors.email && (
                  <span className="text-laptiorange">
                    Sähköposti on vaadittu tieto
                  </span>
                )}
              </label>
              <label className="flex flex-col">
                <span>Osoite</span>
                <input
                  type="text"
                  className="h-10 p-1 bg-white border border-laptiorange"
                  maxLength="250"
                  {...register("address")}
                ></input>
              </label>
              <label className="flex flex-col">
                <span>Postinumero</span>
                <input
                  type="text"
                  {...register("zip")}
                  className="h-10 p-1 bg-white border border-laptiorange"
                  maxLength="5"
                ></input>
              </label>
              <label className="flex flex-col">
                <span>Postitoimipaikka</span>
                <input
                  type="text"
                  {...register("city")}
                  className="h-10 p-1 bg-white border border-laptiorange"
                  maxLength="80"
                ></input>
              </label>
              <button
                className="h-10 mt-6 rounded-pill font-bold text-white border focus:outline-none focus:bg-white focus:text-laptiorange border-laptiorange bg-laptiorange hover:bg-white hover:text-laptiorange"
              >
                {apartment.available
                  ? "Vahvista varaus"
                  : "Liity jonoon"}
              </button>
            </div>
          </form>
          <div className="mt-2">* Pakollinen tieto</div>
        </div>
        <InfoFooter apartment={apartment} />
      </div>
    );
  } else if (state === STATE_SUBMITTING) {
    return (
      <div>
        <InfoHeader apartment={apartment} />
        <ApartmentTitle apartment={apartment} />
        <ApartmentDetails apartment={apartment} />
        <div class="mt-4 flex flex-col items-center">
          <h2 className="text-xl font-bold">
            Lomaketta lähetetään. Ole hyvä ja odota hetkinen...
          </h2>
          <LoadingIndicator />
        </div>
        <InfoFooter apartment={apartment} />
      </div>
    );
  } else if (state === STATE_ERROR) {
    return (
      <div>
        <div>
          <h2 className="text-xl font-bold text-laptiorange">
            Virhe lähettäessä lomaketta. Yritä myöhemmin uudestaan.
          </h2>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <div>
          <h2 className="text-xl font-bold text-laptigreen">
            Lomake lähetetty onnistuneesti!
          </h2>
          <p>Kiitos varauksestasi</p>
          <p>Asuntomyyjämme ottaa sinuun yhteyttä ja vahvistaa varauksen.</p>
        </div>
      </div>
    );
  }
}
